import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import HydrogenLayout from "./layouts/hydrogen/layout";
import NotFound from "./app/not-found";
import { useNavigate } from "react-router-dom";
import Home from "./app/(dashboard)/page";
import UserManagementDashboardPage from "./app/(dashboard)/user-management/page";
import FxRateFeesSettings from "./app/(dashboard)/transactions/settings/fees/page";
import Transactions from "./app/(dashboard)/transactions/page";
import AllCampaign from "./app/(dashboard)/campaign/all-campaign/page";
import UserDetails from "./app/(dashboard)/user-management/user-details/[id]/page";
import CampaignDetails from "./app/(dashboard)/campaign/campaign-details/[id]/page";
import SignIn from "./app/auth/sign-in/page";
import NameChangeDashboardPage from "./app/(dashboard)/name-change/page";
import AllReports from "./app/(dashboard)/campaign/reports/page";
import AllPaymentLink from "./app/(dashboard)/paymentLink/all-paymentLink/page";
import AllDonations from "./app/(dashboard)/paymentLink/all-donations/page";

function RequireAuth({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  useEffect(() => {
    if (!sessionStorage.getItem("admin_token")) {
      navigate("/auth/sign-in");
    }
  }, [navigate]);

  return children;
}

export default function App() {
  return (
    <Routes>
      <Route
        element={
          <RequireAuth>
            <HydrogenLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Home />} />
        <Route
          path="user-management"
          element={<UserManagementDashboardPage />}
        />
        <Route
          path="user-management/user-details/:id"
          element={<UserDetails />}
        />
        <Route path="transactions" element={<Transactions />} />
        <Route
          path="transactions/settings/fees"
          element={<FxRateFeesSettings />}
        />
        <Route path="campaign/all-campaign" element={<AllCampaign />} />
        <Route path="payment-link/all-payment-link" element={<AllPaymentLink />} />
        <Route path="payment-link/all-donations" element={<AllDonations />} />

        <Route path="campaigns/reports" element={<AllReports />} />
        <Route
          path="campaign/campaign-details/:id"
          element={<CampaignDetails />}
        />
        <Route
          path="user-management/name-change-request"
          element={<NameChangeDashboardPage />}
        />
      </Route>

      {/* Public/auth routes */}
      <Route path="auth/sign-in" element={<SignIn />} />

      {/* Catch-all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
